export enum WORKFLOW_BLOCK_TYPE {
  INPUT_DOCUMENT = "input_document",
  INFERENCE = "inference",
  CARD_OUTPUT = "card_output",
  INPUT_STORY_BIBLE = "input_story_bible",
  CLOSE_REQUEST = "close_request",
  API_INPUT = "api_input",
  AB_TEST = "ab_test",
  COST_CONTROLS = "cost_controls",
  FEATURE_FLAGS = "feature_flags",
  POV_AND_TENSE = "pov_and_tense",
}

export type WorkflowBlock = {
  id: string;
  blockType: WORKFLOW_BLOCK_TYPE;
  options: any;
  overrides: BlockOverride[];
};

export type POVAndTenseBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.POV_AND_TENSE;
  options: { }
}

export type FeatureFlagBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.FEATURE_FLAGS;
  options: {
    subscriptionFeatureFlags: {
      id: string;
      name: string;
    }[];
  }
}

export type ApiInputBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.API_INPUT;
  options: {
    variables: { id: string; name: string, description: string }[];
  }
};

export type InputDocumentBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.INPUT_DOCUMENT;
  options: {  }
};

export type InputStoryBibleBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.INPUT_STORY_BIBLE;
  options: {
    disableChiclets?: boolean;
  }
};

export type InferenceBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.INFERENCE;
  options: {
    prompt: {
      type: "chat";
      messages: { role: string; template: string }[];
    }
    stream: boolean;
    temperature: number;
    frequencyPenalty: number;
    presencePenalty: number;
    stop: string;
    numGenerations: number;
    maxTokens: number;
    engine: string;
    disableFallback?: boolean;
  };
};

export enum ABTestPopulation {
  ALL = "all",
  TRIAL = "trial",
  MEMBERS = "members"
}

export enum ABTestAssignmentStrategy {
  REQUEST = "request",
  USER = "user"
}

export type ABTestBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.AB_TEST;
  options: {
    experimentName: string;
    population: ABTestPopulation;
    skipFlaggedContent: boolean;
    assignmentStrategy: ABTestAssignmentStrategy;
    percentage: number;
    controlVariationName: string;
    testVariationName: string;
  }
}

export type CardOutputBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.CARD_OUTPUT;
  options: {
    disableChiclets?: boolean;
  };
};

export type CloseRequestBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.CLOSE_REQUEST;
  options: {};
};

export type CostControlsBlock = WorkflowBlock & {
  blockType: WORKFLOW_BLOCK_TYPE.COST_CONTROLS;
  options: {
    free: boolean;
  }
}

export type WorkflowDefinition = {
  blocks: WorkflowBlock[];
};


export enum BlockOverrideType  {
  SET_OPTIONS = "setOptions",
  SKIP_BLOCK = "skipBlock",
}

export enum BlockOverrideOperator {
  EQUALS = "equals",
  NOT_EQUALS = "not_equals",
}

export enum BlockOverrideJoin {
  AND = "and",
  OR = "or",
}

export type BlockOverride = {
  id: string;
  name: string;
  type: BlockOverrideType;
  criteria: BlockOverrideCriterion[];
  overrides: OptionChange[];
}

export type OptionChange = {
  path: string;
  value: string;
}

export type BlockOverrideCriterion = {
  id: string;
  options: {
    variable: string;
    value: string;
    operator?: BlockOverrideOperator;
    join?: BlockOverrideJoin;
  };
}
